// LibraryLink renders a SPA `<Link>` to the Library detail page at
// `/library/:urn`. Use this anywhere a URN should navigate the user to
// the canonical detail surface — never to a download/artifact endpoint.
//
// Encoding note: URN colons travel verbatim in the URL bar via
// `encodeURI`, matching the navigation convention established alongside
// JOBE-0044.5 / JOBE-0044.6. `useParams` on the detail route auto-
// decodes the param either way; `encodeURI` is preferred so the URL bar
// stays human-readable.
//
// Falls back to plain text when no URN is provided (briefing payloads
// may emit label-only items that don't yet have a canonical entity).

import { Link } from 'react-router-dom';

export function LibraryLink({ urn, label, className }) {
  const text = label || urn || '';
  if (!urn) return text;
  return (
    <Link to={`/library/${encodeURI(urn)}`} className={className}>
      {text}
    </Link>
  );
}
